import EmailIcon from '@mui/icons-material/Email';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import { Box, Menu, MenuItem } from '@mui/material';
import { QuickEmailDialog } from 'apps/wrapper/src/components/shared/template/template-editor/quick-email-dialog/quick-email-dialog';
import { FC, MouseEvent, useMemo, useState } from 'react';
import { CallAction } from './actions/call-action';
import { MessengerAction } from './actions/messenger-action';
import { VideoCallAction } from './actions/video-call-action';
import { CallButton } from './patient-actions.styles';
import { PatientActionsContact } from './types/patient-info';

type PatientActionsProps = {
  locationId: number;
  contact?: PatientActionsContact;
  hideMessengerButton?: boolean;
  onMessengerClick?: (patientId: number) => void;
};

export const PatientActions: FC<PatientActionsProps> = (props) => {
  const { contact, locationId, hideMessengerButton, onMessengerClick } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [quickEmailDialogOpen, setQuickEmailDialogOpen] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleEmailClick = () => {
    setQuickEmailDialogOpen(true);
    setAnchorEl(null);
  };

  if (!contact) return null;

  const isAbleToSendEmail = useMemo(() => contact && contact.email && contact.id && contact.location, [contact]);

  return (
    <>
      <CallButton size="large" onClick={handleClick} sx={{ width: '48px', height: '48px' }}>
        <PermPhoneMsgIcon fontSize="inherit" />
      </CallButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: { backgroundColor: 'white' },
          onMouseLeave: handleClose
        }}
      >
        <CallAction contact={contact} onClose={handleClose} />
        {!hideMessengerButton && (
          <MessengerAction
            contact={contact}
            locationId={locationId}
            onMessengerClick={onMessengerClick}
            onClose={handleClose}
          />
        )}
        <VideoCallAction contact={contact} onClose={handleClose} />
        {isAbleToSendEmail && (
          <MenuItem onClick={handleEmailClick}>
            <EmailIcon color="primary" />
            <Box sx={{ margin: '0 20px 0 10px' }}>Email</Box>
          </MenuItem>
        )}
      </Menu>

      {quickEmailDialogOpen && isAbleToSendEmail && (
        <QuickEmailDialog
          open={quickEmailDialogOpen}
          patientId={contact.id!}
          locationId={contact.location!.id!}
          fromName={contact.location!.name}
          title={`Send Email to ${contact.firstName} ${contact.lastName}`}
          onSend={() => setQuickEmailDialogOpen(false)}
          onClose={() => setQuickEmailDialogOpen(false)}
        />
      )}
    </>
  );
};
